"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("../../../../../utilities/utilities");
var utils_1 = require("../../utils");
var FacebookElement_1 = tslib_1.__importDefault(require("./FacebookElement"));
var FacebookWrapper_1 = tslib_1.__importDefault(require("./FacebookWrapper"));
var FacebookPost = function (_a) {
    var _b = _a.config, data_href = _b.data_href, _c = _b.data_show_text, data_show_text = _c === void 0 ? true : _c, data_width = _b.data_width, config = _a.config;
    // 350 < width < 750
    var width = utils_1.getNumberValueInRange(data_width, 550, 350, 750);
    return (React.createElement(FacebookWrapper_1["default"], { config: config },
        React.createElement(FacebookElement_1["default"], { className: "fb-post", "data-allowfullscreen": "1", "data-href": data_href, "data-show-text": "" + data_show_text, "data-width": width },
            React.createElement("blockquote", { cite: data_href, className: "fb-xfbml-parse-ignore" },
                React.createElement("a", { href: data_href }, utilities_1.__('Facebook príspevok'))))));
};
exports["default"] = FacebookPost;
